import React from 'react';
import TopBar from './TopBar';
import Navigation from './Navigation';
import logo from '../../assets/images/Neuroverseai.png'; // Correct path to logo
import './Header.css';

const Header = () => {
  return (
    <header className="site-header">
      <TopBar />
      <div className="main-header-bar">
        <div className="logo-container">
          <a href="/">
            <img src={logo} alt="NeuroverseAI Logo" className="logo" />
          </a>
        </div>
        <Navigation />
      </div>
    </header>
  );
};

export default Header;